import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';

import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
// import { BusinessTypeProvider } from './contexts';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    {/* <BusinessTypeProvider> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </BusinessTypeProvider> */}
  </Provider>,
);
